import { render, staticRenderFns } from "./BLayoutExpansionTableAsync.vue?vue&type=template&id=27158a10&"
import script from "./BLayoutExpansionTableAsync.vue?vue&type=script&lang=js&"
export * from "./BLayoutExpansionTableAsync.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports